import React, { useState } from 'react';
import './DashboardTabs.css';
import {ResultsPage} from "@/pages/ResultsPage/ResultsPage";
import {VitaminProgramPage} from "@/pages/VitaminProgramPage/VitaminProgramPage";
import {HealthRecommendationsPage} from "@/pages/HealthRecommendationsSection/HealthRecommendationsPage";
import {ScheduleSection} from "@/pages/ScheduleSection/ScheduleSection";
import { NutritionScheduleSection } from "@/pages/NutritionPlanSection/NutritionPlanSection";
import {DayScheduleSection} from "@/pages/DayScheduleSection/DayScheduleSection";


type TabKey =
    | 'health'
    | 'today'
    | 'workout'
    | 'nutrition'
    | 'vitamins'
    | 'stats';

const tabsData: { key: TabKey; label: string; icon: string }[] = [
    { key: 'health', label: 'Уровень Здоровья', icon: '/img/clipboard1.svg' },
    { key: 'today', label: 'План на Сегодня', icon: '/img/calendar-silhouette1.svg' },
    { key: 'workout', label: 'План Тренировок', icon: '/img/girya.svg' },
    { key: 'nutrition', label: 'План Питания', icon: '/img/vilka.svg' },
    { key: 'vitamins', label: 'Витамины', icon: '/img/supplement1.svg' },
    { key: 'stats', label: 'Статистика', icon: '/img/graph1.svg' },
];


export const DashboardTabs: React.FC = () => {
    const [activeTab, setActiveTab] = useState<TabKey>('health');

    const renderContent = () => {
        switch (activeTab) {
            case 'health': return <HealthRecommendationsPage />;
            case 'today': return <DayScheduleSection />;
            case 'workout': return <ScheduleSection />;
            case 'nutrition': return <NutritionScheduleSection />;
            case 'vitamins': return <VitaminProgramPage />;
            case 'stats': return<ResultsPage
                month="июнь"
                analyticsData={{
                    nutrition_itog: 80,
                    trainings_itog: 60,
                    vitamins_itog: 90,
                    labels: ['1', '2', '3', '4', '5'],
                    nutrition_data: [80, 60, 70, 90, 100],
                    trainings_data: [50, 70, 65, 80, 60],
                    vitamins_data: [90, 95, 100, 85, 70],
                }}
            />;
            default: return null;
        }
    };

    return (
        <div className="container">
            <div className="dashboard-tabs">
                <div className="tabs-bar">
                    {tabsData.map(({ key, label, icon }) => (
                        <button
                            key={key}
                            className={`tab-button ${activeTab === key ? 'active' : ''}`}
                            onClick={() => setActiveTab(key)}
                        >
                            <img src={icon} alt="" className="tab-icon" />
                            {label}
                        </button>
                    ))}
                </div>
                <div className="tab-content">
                    {renderContent()}
                </div>
            </div>
        </div>

    );
};
